import { defineComponent as T, computed as w, ref as d, reactive as B, watch as f, onMounted as $, onBeforeUnmount as j, createElementBlock as v, openBlock as m, Fragment as I, createElementVNode as r, createVNode as q, unref as A, normalizeStyle as N, createCommentVNode as P, withModifiers as b, toDisplayString as k, renderList as z, normalizeClass as H } from "vue";
import { ScalarIconTextAlignLeft as L } from "@scalar/icons";
import { EditorClasses as M } from "@scalar-org/css";
const D = { class: "header" }, F = { class: "container" }, R = {
  key: 0,
  class: "level-1"
}, U = ["id"], Y = ["href", "onClick"], G = "__", W = /* @__PURE__ */ T({
  __name: "TableOfContents",
  props: {
    headings: {},
    pageTitle: {}
  },
  setup(s) {
    const p = s, g = w(
      () => Object.values(p.headings || {}).filter((e) => e.level === 1 || e.level === 2 || e.level === 3).map((e) => e.slug)
    ), C = (e) => e.split(G).length, o = d(""), a = d(""), l = B({}), c = w(
      () => Object.values(l).sort((e, t) => e.order - t.order)
    ), h = d([]), y = d(0);
    function _() {
      Object.keys(l).forEach((e) => {
        g.value.includes(e) || delete l[e];
      }), g.value.forEach((e, t) => {
        l[e] = {
          id: e,
          inView: l[e]?.inView ?? !1,
          order: t
        };
      });
    }
    f(g, () => _(), { immediate: !0, deep: !0 });
    const O = (e) => {
      e.forEach((t) => {
        if (l[t.target.id] && (l[t.target.id].inView = t.isIntersecting), a.value = t.target.id, !t.isIntersecting && t.target.getBoundingClientRect().top >= window.innerHeight * 0.2 && Object.values(l).every((u) => !u.inView)) {
          const u = c.value.findIndex(
            (x) => x.id === t.target.id
          );
          u >= 1 && (a.value = c.value[u - 1].id);
        }
      });
    };
    f(
      [a, c],
      () => {
        const e = c.value.find((t) => t.inView);
        if (e) {
          o.value = e.id;
          return;
        }
        if (a.value) {
          o.value = a.value;
          return;
        }
      },
      { immediate: !0, deep: !0 }
    );
    let i;
    function E() {
      i && i.disconnect(), document.querySelectorAll(
        '[data-scalar-type="heading"][data-level="1"], [data-scalar-type="heading"][data-level="2"], [data-scalar-type="heading"][data-level="3"]'
      ).forEach((t) => i?.observe(t));
    }
    $(() => {
      i = new IntersectionObserver(O, {
        // threshold: 1,
        // rootMargin: '-20%',
      }), E();
    }), j(() => {
      i?.disconnect();
    }), f(
      () => Object.keys(p.headings || {}),
      () => {
        h.value = [], E();
      }
    );
    function S(e) {
      o.value = e.slug, window.location.replace(`#${e.slug}`), document.getElementById(e.slug)?.scrollIntoView();
    }
    function V() {
      document.querySelector(`.${M.PageTitle} h1`)?.scrollIntoView();
    }
    return f(o, () => {
      const e = h.value.find(
        (t) => t.querySelector(".anchor")?.getAttribute("href") === `#${o.value}`
      );
      e && (y.value = e.offsetTop);
    }), (e, t) => (m(), v(I, null, [
      r("div", D, [
        q(A(L)),
        t[0] || (t[0] = r("h4", null, "On This Page", -1))
      ]),
      r("div", F, [
        r("div", {
          class: "outline-marker",
          style: N({
            transform: `translateY(${y.value}px)`
          })
        }, null, 4),
        r("ul", null, [
          Object.keys(s.headings || {}).length === 0 ? (m(), v("li", R, [
            r("a", {
              class: "anchor",
              href: "#",
              onClick: b(V, ["prevent"])
            }, k(s.pageTitle), 1)
          ])) : P("", !0),
          (m(!0), v(I, null, z(s.headings, (n) => (m(), v("li", {
            id: n.uid,
            key: n.uid,
            ref_for: !0,
            ref_key: "tocItems",
            ref: h,
            class: H([
              `level-${n.level}`,
              `toc-indent-${C(n.slug)}`,
              { active: o.value === n.slug }
            ])
          }, [
            r("a", {
              class: "anchor",
              href: `#${n.slug}`,
              onClick: b(() => S(n), ["prevent"])
            }, k(n.name), 9, Y)
          ], 10, U))), 128))
        ])
      ])
    ], 64));
  }
});
export {
  W as default
};
